import _jsx from "@babel/runtime/helpers/jsx";
var _span;
import PropTypes from 'prop-types';
import React from 'react';
class CloseButton extends React.Component {
  render() {
    const {
      label = 'Close',
      onClick
    } = this.props;
    return /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "close",
      onClick: onClick
    }, void 0, _span || (_span = /*#__PURE__*/_jsx("span", {
      "aria-hidden": "true"
    }, void 0, "\xD7")), /*#__PURE__*/_jsx("span", {
      className: "sr-only"
    }, void 0, label));
  }
}
export default CloseButton;